import React from "react";
import "./About.css";
import profilePicture from "./profilePicture1.gif";
function About() {
  return (
    <div className="about text-center p-2 d-flex justify-content-center align-items-center">
      <img src={profilePicture} alt="" />
      <b className="display-6 ">
        "Focused on continuous learning and practical problem-solving, I’m eager
        to bring my skills and fresh perspectives to impactful projects. Looking
        for opportunities to collaborate, grow, and contribute to a dynamic
        team."
      </b>
    </div>
  );
}

export default About;
